// extracted by mini-css-extract-plugin
export default {"container":"container-Phl3P_ZR","blue":"blue-G8oosm8L","beige":"beige-RdMs0LF_"};